import { useState } from "react";
import { Button, Checkbox } from "antd";

import styles from "./CarList.module.css";
import bukgi from "../assets/images/car/bukgi-car.png";
import yaxing from "../assets/images/car/carList-yaxing-car.png";

function CarList({
    carId,
    carNumber,
    isActive,
    onActiveCar,
    isDelete,
    deleteCarList,
    setDeleteCarList,
    isYaxing,
}: {
    carId?: number;
    carNumber: string;
    isActive: boolean;
    onActiveCar?: (carNumber: string) => void;
    isDelete?: boolean;
    deleteCarList: number[];
    setDeleteCarList: (list: number[]) => void;
    isYaxing?: boolean;
}) {
    const [check, setCheck] = useState(false);

    return (
        <Button
            disabled={carNumber === "" ? true : false}
            onClick={
                isDelete
                    ? () => {
                          setCheck((prev) => !prev);
                          check
                              ? setDeleteCarList(deleteCarList.filter((value) => value !== carId))
                              : setDeleteCarList(carId ? deleteCarList.concat(carId) : []);
                      }
                    : isActive
                    ? () => {}
                    : () => onActiveCar && onActiveCar(carNumber)
            }
            className={isDelete ? `${styles.inactiveBody}` : isActive ? `${styles.activeBody}` : `${styles.inactiveBody}`}
        >
            <Checkbox
                style={{ width: 24, height: 24 }}
                className={`${styles.checkbox} ${isDelete ? "" : styles.hideCheck}`}
                disabled={!isDelete}
                checked={check}
            ></Checkbox>
            {carNumber === "" ? (
                <div className={styles.emptyText}>
                    <p>보유 중인 차량이 없습니다.</p>
                    <p>차량 등록 후 사용해 주세요.</p>
                </div>
            ) : (
                <div className={styles.innerBody}>
                    <img width={200} height={140} src={isYaxing ? yaxing : bukgi} className={styles.carImg} alt="ruta40 camping car" />

                    <p className={styles.carNumberText}>{carNumber}</p>
                    <p className={styles.activeText}>{isActive ? "사용중" : ""}</p>
                </div>
            )}
        </Button>
    );
}

export default CarList;
